import { trustHighlightData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function TrustHighlight() {
  return (
    <section className="py-10 md:py-14 bg-background-50 border-b border-background-200/50">
      <div className="container-astro">
        <AnimatedSection>
          <div className="max-w-2xl mx-auto text-center">
            {/* Star rating */}
            <div className="flex items-center justify-center gap-1 mb-4">
              {Array.from({ length: trustHighlightData.rating }).map((_, i) => (
                <span key={i} className="text-amber-400 text-lg md:text-xl">
                  <i className="ri-star-fill" />
                </span>
              ))}
            </div>

            {/* Quote */}
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-5 font-medium italic">
              &ldquo;{trustHighlightData.quote}&rdquo;
            </p>

            {/* Attribution */}
            <div className="flex flex-col items-center gap-1">
              <p className="text-sm font-bold text-foreground-950 font-heading">
                {trustHighlightData.name}
              </p>
              <p className="text-xs text-foreground-500">
                {trustHighlightData.position}, {trustHighlightData.company}
              </p>
            </div>

            {/* Divider with tagline */}
            <div className="flex items-center gap-4 mt-8">
              <div className="h-px flex-1 bg-gradient-to-r from-transparent to-background-300/60" />
              <p className="text-xs md:text-sm font-semibold text-foreground-500 font-heading tracking-wide">
                Built for businesses that expect more from technology
              </p>
              <div className="h-px flex-1 bg-gradient-to-l from-transparent to-background-300/60" />
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}